export default [
  { value: '', label: '-- Selecione --' },
  { value: 'fa fa-archive', label: 'caixa' },
  { value: 'fab fa-android', label: 'android' },
  { value: 'fa fa-mobile', label: 'mobile' },
  { value: 'fab fa-angellist', label: 'certo' },
  { value: 'fa fa-align-left', label: 'alinhar à esquerda' },
  { value: 'fa fa-align-right', label: 'alinhar à direita' },
  { value: 'fab fa-amazon', label: 'amazon' },
  { value: 'fa fa-ambulance', label: 'ambulância' },
  { value: 'fa fa-anchor', label: 'âncora' },
  { value: 'fab fa-apple', label: 'maçã' },
  { value: 'fas fa-chart-area', label: 'gráfico de área' },
  { value: 'fa fa-arrow-circle-down', label: 'flecha' },
  { value: 'fa fa-arrow-circle-left', label: 'flecha' },
  { value: 'fa fa-arrow-circle-down', label: 'flecha' },
  { value: 'fa fa-arrow-circle-left', label: 'flecha' },
  { value: 'fa fa-arrow-circle-right', label: 'flecha' },
  { value: 'fa fa-arrow-circle-up', label: 'flecha' },
  { value: 'fa fa-arrow-circle-right', label: 'flecha' },
  { value: 'fa fa-arrow-circle-up', label: 'flecha' },
  { value: 'fa fa-arrow-down', label: 'flecha' },
  { value: 'fa fa-arrow-left', label: 'flecha' },
  { value: 'fa fa-arrow-right', label: 'flecha' },
  { value: 'fa fa-arrow-up', label: 'flecha' },
  { value: 'fa fa-arrows-alt', label: 'setas' },
  { value: 'fa fa-arrows-alt-h', label: 'setas' },
  { value: 'fa fa-arrows-alt-v', label: 'setas' },
  { value: 'fa fa-asterisk', label: 'asterisk' },
  { value: 'fa fa-at', label: 'arroba' },
  { value: 'fa fa-car', label: 'automóvel' },
  { value: 'fa fa-balance-scale', label: 'balança de equilíbrio' },
  { value: 'fa fa-ban', label: 'bloqueio' },
  { value: 'fa fa-piggy-bank', label: 'banco' },
  { value: 'fa fa-chart-bar', label: 'gráfico de barras' },
  { value: 'fa fa-battery-full', label: 'bateria cheia' },
  { value: 'fab fa-behance', label: 'behance' },
  { value: 'fab fa-behance-square', label: 'behance' },
  { value: 'fa fa-bell', label: 'sino' },
  { value: 'fa fa-bell-slash', label: 'sino' },
  { value: 'fa fa-bicycle', label: 'bicicleta' },
  { value: 'fa fa-binoculars', label: 'binóculos' },
  { value: 'fa fa-birthday-cake', label: 'bolo de aniversário' },
  { value: 'fab fa-bitbucket', label: 'bitbucket' },
  { value: 'fab fa-bitcoin', label: 'bitcoin' },
  { value: 'fab fa-black-tie', label: 'gravata preta' },
  { value: 'fa fa-bold', label: 'bold' },
  { value: 'fa fa-bolt', label: 'raio' },
  { value: 'fa fa-bomb', label: 'bomba' },
  { value: 'fa fa-book', label: 'livro' },
  { value: 'fa fa-bookmark', label: 'marca páginas' },
  { value: 'fa fa-briefcase', label: 'pasta' },
  { value: 'fa fa-bug', label: 'besouro' },
  { value: 'far fa-building', label: 'construção' },
  { value: 'fas fa-building', label: 'construção' },
  { value: 'fa fa-bullhorn', label: 'amplificador' },
  { value: 'fa fa-bullseye', label: 'alvo' },
  { value: 'fa fa-bus', label: 'ônibus' },
  { value: 'fa fa-calendar', label: 'calendário' },
  { value: 'fa fa-camera', label: 'camera' },
  { value: 'fa fa-car', label: 'carro' },
  { value: 'fa fa-caret-up', label: 'circunflexo' },
  { value: 'fa fa-cart-plus', label: 'carrinho' },
  { value: 'fa fa-check', label: 'check' },
  { value: 'fa fa-child', label: 'criança' },
  { value: 'fab fa-chrome', label: 'chrome' },
  { value: 'far fa-circle', label: 'círculo' },
  { value: 'fas fa-circle', label: 'círculo' },
  { value: 'fa fa-clipboard', label: 'prancheta' },
  { value: 'fas fa-clock', label: 'relógio' },
  { value: 'fa fa-clone', label: 'clone' },
  { value: 'fa fa-window-close', label: 'fechar' },
  { value: 'fas fa-cloud', label: 'nuvem' },
  { value: 'fa fa-cloud-download-alt', label: 'nuvem' },
  { value: 'fa fa-cloud-upload-alt', label: 'nuvem' },
  { value: 'fa fa-code', label: 'código' },
  { value: 'fab fa-codepen', label: 'codepen' },
  { value: 'fa fa-coffee', label: 'café' },
  { value: 'fa fa-cog', label: 'roda dentada' },
  { value: 'fa fa-cogs', label: 'rodas dentada' },
  { value: 'fa fa-columns', label: 'colunas' },
  { value: 'fa fa-comment', label: 'comente' },
  { value: 'fa fa-comment-alt', label: 'comentando' },
  { value: 'fa fa-comments', label: 'comentários' },
  { value: 'fa fa-compass', label: 'bússola' },
  { value: 'fa fa-compress', label: 'comprimir' },
  { value: 'fab fa-connectdevelop', label: 'conectar-se' },
  { value: 'fab fa-contao', label: 'sgc' },
  { value: 'fa fa-copy', label: 'copia' },
  { value: 'fa fa-copyright', label: 'copyright' },
  { value: 'fab fa-creative-commons', label: 'creative commons' },
  { value: 'fa fa-credit-card', label: 'cartão de crédito' },
  { value: 'fa fa-crop', label: 'colheita' },
  { value: 'fa fa-crosshairs', label: 'mira' },
  { value: 'fab fa-css3', label: 'css3' },
  { value: 'fa fa-cube', label: 'cubo' },
  { value: 'fa fa-cubes', label: 'cubos' },
  { value: 'fa fa-cut', label: 'cortar' },
  { value: 'fab fa-dashcube', label: 'dashcube' },
  { value: 'fa fa-database', label: 'database' },
  { value: 'fab fa-delicious', label: 'delicioso' },
  { value: 'fa fa-desktop', label: 'desktop' },
  { value: 'fab fa-deviantart', label: 'deviant art' },
  { value: 'fab fa-digg', label: 'digg' },
  { value: 'fa fa-dollar-sign', label: 'dollar' },
  { value: 'fa fa-download', label: 'download' },
  { value: 'fab fa-dribbble', label: 'dribbble' },
  { value: 'fab fa-dropbox', label: 'dropbox' },
  { value: 'fab fa-drupal', label: 'drupal' },
  { value: 'fa fa-edit', label: 'editar' },
  { value: 'fa fa-eject', label: 'ejetar' },
  { value: 'fa fa-ellipsis-h', label: 'elipses-h' },
  { value: 'fa fa-ellipsis-v', label: 'elipses-v' },
  { value: 'fab fa-empire', label: 'Império' },
  { value: 'fas fa-envelope', label: 'envelope' },
  { value: 'fa fa-euro-sign', label: 'euro' },
  { value: 'fa fa-exchange-alt', label: 'exchange' },
  { value: 'fa fa-exclamation', label: 'exclamação' },
  { value: 'fa fa-exclamation-circle', label: 'exclamação' },
  { value: 'fa fa-exclamation-triangle', label: 'exclamação' },
  { value: 'fa fa-expand', label: 'expandir' },
  { value: 'fab fa-expeditedssl', label: 'cadeado' },
  { value: 'fa fa-external-link-alt', label: 'link externo' },
  { value: 'fa fa-external-link-square-alt', label: 'link externo' },
  { value: 'fa fa-eye', label: 'olho' },
  { value: 'fa fa-eye-slash', label: 'olho' },
  { value: 'fab fa-facebook', label: 'facebook' },
  { value: 'fab fa-facebook-f', label: 'facebook' },
  { value: 'fab fa-facebook-square', label: 'facebook' },
  { value: 'fa fa-fast-backward', label: 'atraso rápido' },
  { value: 'fa fa-fast-forward', label: 'avanço rápido' },
  { value: 'fa fa-fax', label: 'fax' },
  { value: 'fa fa-female', label: 'mulher' },
  { value: 'fa fa-fighter-jet', label: 'jato' },
  { value: 'fa fa-file', label: 'arquivo' },
  { value: 'fa fa-file-archive', label: 'compactado' },
  { value: 'fa fa-file-audio', label: 'audio' },
  { value: 'fa fa-file-code', label: 'code' },
  { value: 'fa fa-file-excel', label: 'excel' },
  { value: 'fa fa-file-image', label: 'imagem' },
  { value: 'fa fa-file-video', label: 'video' },
  { value: 'fa fa-file-pdf', label: 'pdf' },
  { value: 'fa fa-photo-video', label: 'foto' },
  { value: 'fa fa-file-powerpoint', label: 'powerpoint' },
  { value: 'fab fa-soundcloud', label: 'soundcloud' },
  { value: 'fa fa-file-word', label: 'word' },
  { value: 'fa fa-compact-disc', label: 'disco' },
  { value: 'fa fa-film', label: 'filme' },
  { value: 'fa fa-filter', label: 'filtro' },
  { value: 'fa fa-fire', label: 'fogo' },
  { value: 'fa fa-fire-extinguisher', label: 'extintor' },
  { value: 'fab fa-firefox', label: 'firefox' },
  { value: 'fa fa-flag', label: 'bandeira' },
  { value: 'fa fa-flag-checkered', label: 'bandeira xadrez' },
  { value: 'fas fa-flag', label: 'bandeira' },
  { value: 'fa fa-flask', label: 'frasco' },
  { value: 'fab fa-flickr', label: 'flickr' },
  { value: 'fa fa-folder', label: 'pasta' },
  { value: 'fa fa-folder-open', label: 'pasta aberta' },
  { value: 'fa fa-font', label: 'fonte' },
  { value: 'fab fa-fonticons', label: 'icones' },
  { value: 'fab fa-forumbee', label: 'abelha' },
  { value: 'fa fa-forward', label: 'próximo' },
  { value: 'fab fa-foursquare', label: 'foursquare' },
  { value: 'fa fa-frown', label: 'triste' },
  { value: 'fa fa-futbol', label: 'futebol' },
  { value: 'fa fa-gamepad', label: 'game' },
  { value: 'fa fa-gavel', label: 'martelo' },
  { value: 'fa fa-gift', label: 'presente' },
  { value: 'fab fa-git', label: 'git' },
  { value: 'fab fa-git-square', label: 'git' },
  { value: 'fab fa-github', label: 'github' },
  { value: 'fab fa-github-alt', label: 'github' },
  { value: 'fab fa-github-square', label: 'github' },
  { value: 'fa fa-glass-cheers', label: 'brinde' },
  { value: 'fas fa-globe', label: 'globo' },
  { value: 'fab fa-google', label: 'google' },
  { value: 'fab fa-google-plus', label: 'google' },
  { value: 'fab fa-google-plus-square', label: 'google' },
  { value: 'fab fa-google-wallet', label: 'google' },
  { value: 'fa fa-graduation-cap', label: 'chapéu de graduação' },
  { value: 'fa fa-hand-lizard', label: 'mão' },
  { value: 'fa fa-hand-paper', label: 'mão' },
  { value: 'fa fa-hand-peace', label: 'mão' },
  { value: 'fa fa-hand-pointer', label: 'mão' },
  { value: 'fa fa-hand-rock', label: 'mão' },
  { value: 'fa fa-hand-scissors', label: 'mão' },
  { value: 'fa fa-hand-spock', label: 'mão' },
  { value: 'fa fa-hdd', label: 'hdd' },
  { value: 'fa fa-headphones', label: 'fones de ouvido' },
  { value: 'fa fa-heart', label: 'coração' },
  { value: 'fa fa-heartbeat', label: 'coração' },
  { value: 'fa fa-history', label: 'histórico' },
  { value: 'fa fa-home', label: 'casa' },
  { value: 'fa fa-hospital', label: 'hospital' },
  { value: 'fa fa-hotel', label: 'hotel' },
  { value: 'fa fa-hourglass', label: 'ampulheta' },
  { value: 'fa fa-hourglass-end', label: 'ampulheta' },
  { value: 'fa fa-hourglass-half', label: 'ampulheta' },
  { value: 'fa fa-hourglass-start', label: 'ampulheta' },
  { value: 'fab fa-houzz', label: 'houzz' },
  { value: 'fab fa-html5', label: 'html5' },
  { value: 'fa fa-i-cursor', label: 'cursor' },
  { value: 'fa fa-utensils', label: 'talheres' },
  { value: 'fa fa-image', label: 'image' },
  { value: 'fa fa-inbox', label: 'inbox' },
  { value: 'fa fa-indent', label: 'recuar' },
  { value: 'fa fa-industry', label: 'indústria' },
  { value: 'fa fa-info', label: 'informação' },
  { value: 'fa fa-info-circle', label: 'informação' },
  { value: 'fab fa-instagram', label: 'instagram' },
  { value: 'fab fa-internet-explorer', label: 'internet explorer' },
  { value: 'fab fa-ioxhost', label: 'ioxhost' },
  { value: 'fa fa-italic', label: 'italico' },
  { value: 'fab fa-joomla', label: 'joomla' },
  { value: 'fab fa-jsfiddle', label: 'jsfiddle' },
  { value: 'fa fa-key', label: 'chave' },
  { value: 'fa fa-keyboard', label: 'teclado' },
  { value: 'fa fa-language', label: 'língua' },
  { value: 'fa fa-laptop', label: 'laptop' },
  { value: 'fa fa-leaf', label: 'folha' },
  { value: 'fab fa-leanpub', label: 'ler' },
  { value: 'fa fa-lemon', label: 'limão' },
  { value: 'fa fa-level-down-alt', label: 'level' },
  { value: 'fa fa-life-ring', label: 'salva vidas' },
  { value: 'fa fa-lightbulb', label: 'lâmpada' },
  { value: 'fa fa-chart-line', label: 'gráfico de linha' },
  { value: 'fa fa-link', label: 'link' },
  { value: 'fab fa-linkedin', label: 'linkedin' },
  { value: 'fab fa-linux', label: 'linux' },
  { value: 'fa fa-list', label: 'lista' },
  { value: 'fa fa-list-alt', label: 'lista' },
  { value: 'fa fa-list-ol', label: 'lista' },
  { value: 'fa fa-list-ul', label: 'lista' },
  { value: 'fa fa-location-arrow', label: 'localização' },
  { value: 'fa fa-lock', label: 'trancar' },
  { value: 'fa fa-magic', label: 'magica' },
  { value: 'fa fa-magnet', label: 'magnético' },
  { value: 'fa fa-medkit', label: 'quit médico' },
  { value: 'fa fa-microphone', label: 'microfone' },
  { value: 'fa fa-motorcycle', label: 'motocicleta' },
  { value: 'fa fa-mouse-pointer', label: 'ponteiro' },
  { value: 'fa fa-music', label: 'música' },
  { value: 'fa fa-location-arrow', label: 'navegação' },
  { value: 'fa fa-neuter', label: 'lupa' },
  { value: 'fa fa-newspaper', label: 'jornal' },
  { value: 'fab fa-opera', label: 'opera' },
  { value: 'fa fa-paper-plane', label: 'avião de papel' },
  { value: 'fa fa-paperclip', label: 'clip' },
  { value: 'fa fa-paragraph', label: 'paragrafo' },
  { value: 'fa fa-paste', label: 'colar' },
  { value: 'fa fa-pause', label: 'pause' },
  { value: 'fa fa-paw', label: 'pata' },
  { value: 'fab fa-paypal', label: 'paypal' },
  { value: 'fa fa-pencil-alt', label: 'lápis' },
  { value: 'fa fa-pencil-ruler', label: 'lápis e régua' },
  { value: 'fa fa-phone', label: 'fone' },
  { value: 'fa fa-chart-pie', label: 'gráfico de pizza' },
  { value: 'fab fa-pinterest', label: 'pinterest' },
  { value: 'fab fa-pinterest-p', label: 'pinterest' },
  { value: 'fab fa-pinterest-square', label: 'pinterest' },
  { value: 'fa fa-plane', label: 'avião' },
  { value: 'fa fa-play', label: 'play' },
  { value: 'fa fa-play-circle', label: 'play' },
  { value: 'fa fa-plug', label: 'plug' },
  { value: 'fa fa-plus', label: 'plus' },
  { value: 'fa fa-plus-circle', label: 'plus' },
  { value: 'fa fa-plus-square', label: 'plus' },
  { value: 'fa fa-power-off', label: 'power off' },
  { value: 'fa fa-print', label: 'impressão' },
  { value: 'fa fa-puzzle-piece', label: 'quebra cabeças' },
  { value: 'fa fa-qrcode', label: 'qrcode' },
  { value: 'fa fa-question', label: 'questão' },
  { value: 'fa fa-question-circle', label: 'questão' },
  { value: 'fa fa-random', label: 'random' },
  { value: 'fa fa-recycle', label: 'reciclar' },
  { value: 'fab fa-reddit', label: 'reddit' },
  { value: 'fab fa-reddit-square', label: 'reddit' },
  { value: 'fa fa-registered', label: 'registrar' },
  { value: 'fa fa-remove-format', label: 'remover formatação' },
  { value: 'fa fa-reply', label: 'resposta' },
  { value: 'fa fa-road', label: 'estrada' },
  { value: 'fa fa-rocket', label: 'foguete' },
  { value: 'fa fa-envelope-open', label: 'e-mail' },
  { value: 'fa fa-tint', label: 'gota' },
  { value: 'fa fa-rss', label: 'rss' },
  { value: 'fa fa-rss-square', label: 'rss' },
  { value: 'fab fa-safari', label: 'safari' },
  { value: 'fa fa-sliders-h', label: 'sliders' },
  { value: 'fab fa-slideshare', label: 'slideshare' },
  { value: 'fa fa-spinner', label: 'spinner' },
  { value: 'fab fa-spotify', label: 'spotify' },
  { value: 'fa fa-square', label: 'quadrado' },
  { value: 'fa fa-star', label: 'estrela' },
  { value: 'fa fa-stop', label: 'stop' },
  { value: 'fa fa-tablet', label: 'tablet' },
  { value: 'fa fa-tag', label: 'tag' },
  { value: 'fa fa-tags', label: 'tags' }
];
